// Handle name object / string //
export const handleName = (
  name: string | { en?: string; fr?: string }
): string => {
  if (typeof name === 'string') return name
  return name.en ?? ''
}

// Find distance between 2 coordinates
export function distance(
  pointA: {
    x: number
    y: number
  },
  pointB: {
    x: number
    y: number
  }
) {
  const x = Math.abs(pointA.x - pointB.x),
    y = Math.abs(pointA.y - pointB.y)
  const distance = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2))
  return distance
}

// Get ordinal string for a number (1st, 2nd, 3rd, etc)
export const getOrdinal = (num: number): string => {
  const suffix = ['th', 'st', 'nd', 'rd']
  const value = num % 100
  return num + (suffix[(value - 20) % 10] || suffix[value] || 'th')
}
